import { render } from "./offer.offerBank.vue?vue&type=template&id=5ff39c52"
import script from "./offer.offerBank.vue?vue&type=script&lang=js"
export * from "./offer.offerBank.vue?vue&type=script&lang=js"

import "./offer.offerBank.vue?vue&type=style&index=0&id=5ff39c52&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__